module.exports = function() {
  return new Worker(__webpack_public_path__ + "2c7d7b8ceea07941998f.worker.js");
};